import { useSelector } from "react-redux"
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {formatDinero} from "./../../../../utils/formatDinero"
const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });

const TablaMovimientos = () => {
    const { movimientos } = useSelector(store => store.calendario)
    const classes = useStyles();
    return (
        <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Referencia</TableCell>
              <TableCell align="center">Calve de Rastreo</TableCell>
              <TableCell align="center">Fecha de Pago</TableCell>
              <TableCell align="center">Monto</TableCell>
              <TableCell align="center">Tipo Cambio</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {movimientos.map((row, index) => (
              <TableRow key={index+1}>
                <TableCell align="center" component="th" scope="row">
                  {row.Referencia}
                </TableCell>
                <TableCell align="center">{row.ClaveRastreo}</TableCell>
                <TableCell align="center">{row?.Fecha.split("T")[0]}</TableCell>
                <TableCell align="center">{formatDinero(row?.monto)}</TableCell>
                <TableCell align="center">{row.tipoCambio}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
}
export default TablaMovimientos